import axios from 'axios'
import { Auth } from 'aws-amplify'

const client = axios.create({ baseURL: process.env.VUE_APP_BILLING_API || process.env.VUE_APP_ROOT_API, timeout: 30000 })

async function request(method, path, data, requestKey) {
  const session = await Auth.currentSession()
  const response = await client.request({
    method,
    url: `/billing/${path}`,
    data,
    headers: {
      Authorization: session.getAccessToken().getJwtToken(),
      ...(requestKey ? { 'Idempotency-Key': requestKey } : {}),
    },
  })

  return response.data
}

export function newRequestKey() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)

  return Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
}

export function billingError(error) {
  if (error.response && error.response.data && error.response.data.message) return error.response.data.message

  return 'Billing is temporarily unavailable. Please try again.'
}

export function openStripePage(url, kind = 'checkout') {
  const parsed = new URL(url)
  const allowedHost = kind === 'portal' ? 'billing.stripe.com' : 'checkout.stripe.com'
  if (parsed.protocol !== 'https:' || parsed.hostname !== allowedHost || parsed.username || parsed.password) {
    throw new Error('Invalid payment destination')
  }
  window.location.assign(parsed.href)
}

export default {
  async catalog() {
    const response = await client.get('/billing/catalog')

    return response.data
  },
  summary: () => request('get', 'me'),
  history: () => request('get', 'history'),
  checkout: (offerId, key) => request('post', 'checkout', { offerId }, key),
  cancelCheckout: () => request('post', 'checkout/cancel', {}),
  portal: () => request('post', 'portal', {}),
}
